export const NotFound = () => {
  return <div>Not found!</div>
}
